import { render, staticRenderFns } from "./modalFileSecond.vue?vue&type=template&id=9982a11a&"
import script from "./modalFileSecond.vue?vue&type=script&lang=js&"
export * from "./modalFileSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports